module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/api-0f97e89aae68f0e89fa97fbe97b9d06e.svg";